import Chip from '@mui/material/Chip'
import Autocomplete from '@mui/material/Autocomplete'
import TextField, { TextFieldProps } from '@mui/material/TextField'
import SearchIcon from '@mui/icons-material/Search'
import { Grid, IconButton, Tooltip } from '@mui/material'
import { CSSProperties, useEffect, useRef, useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'

export default function CustomizedSearch(props: {
	isDisable?: boolean
	value: (string | never[])[]
	setGlobalSearch?: any
	sx?: CSSProperties
	handleOnSearch: (selectedValue: (string | never[])[]) => void
}) {
	const { value, sx, handleOnSearch, setGlobalSearch } = props
	const [inputValue, setInputValue] = useState('')

	const searchValues = (chips: (string | never[])[], newInputValue: "" | string) => {
		if(chips?.length === 0 && newInputValue !== ''){
			setGlobalSearch([newInputValue])
			handleOnSearch([newInputValue])
		}else if(chips?.length === 0 && newInputValue === ''){
			handleOnSearch([])
		}else if(chips?.length !== 0 && newInputValue === ''){
			handleOnSearch([...chips])
		}else if(chips?.length !== 0 && newInputValue !== ''){
			setGlobalSearch([...chips, newInputValue])
			handleOnSearch([...chips, newInputValue])
		}
	}
 	const handleKeyDown = (event:any) => {
		const chips = value
		const newInputValue = inputValue.trim()
		if(event.key === 'Enter'){
			searchValues(chips, newInputValue)
			setInputValue('')
		}
		if(event.key === 'Tab'){
			event.preventDefault()
			if(newInputValue !== ''){
				setGlobalSearch([...chips, newInputValue])
			}
			setInputValue('')
		}
	};

	const clickToSearch = () => {
		const chips = value
		const newInputValue = inputValue.trim()
		searchValues(chips, newInputValue)
		setInputValue('')
	}

	const clickToCross = () => {
		setGlobalSearch([])
	}

	const handleDeleteChip = (index: number) => {
		const newValue = [...value];
		newValue.splice(index, 1);
		setGlobalSearch(newValue)
	}

	return (
		<Grid
			container
			alignItems={'center'}
			sx={
				sx ?? {
					width: '30%',
					padding: '8px',
				}
			}
		>
			<Grid item xs={10}>
				{value?.map((elem: any, index: number)=>{
					return (
						<Chip key={index}
							sx={{margin: '2px'}} 
							label={elem}
							onDelete={()=>handleDeleteChip(index)}
						/>)
				})}
			</Grid>
			{value.length? <Grid item xs={1}>
				<Tooltip title={"remove all chips"} placement={"top"} followCursor>
					<IconButton onClick={clickToCross} disabled={value?.length === 0}>
						<CloseIcon />
					</IconButton>
				</Tooltip>
				
			</Grid>: null}
			
			<Grid item xs={10}>
				{/* <Autocomplete
					id="search-autocomplete"
					defaultValue={[]}
					value={value}
					multiple
					options={[]}
					freeSolo
					disabled={props.isDisable}
					onChange={(event, newValue = []) => {
						handleOnSearch(newValue)
					}}
					renderTags={(value, getTagProps) =>
						value.map((option, index) => (
							<Chip variant="outlined" label={option} {...getTagProps({ index })} />
					))
					}
					renderInput={({ InputLabelProps, ...params }) => (
						<TextField
							{...params}
							InputLabelProps={InputLabelProps as TextFieldProps['InputLabelProps']}
							variant="standard"
							InputProps={{ ...(params.InputProps || {}) }}
							placeholder="Press Enter for search"
						/>
					)}
				/> */}
				<TextField
					onChange={(event) => {
						setInputValue(event.target.value)
					}}
					value={inputValue || ''}
					variant="standard"
					sx={{ width: '100%'}}
					type={'text'}
                    onKeyDown={handleKeyDown}
				/>
			</Grid>
			
			<Grid item xs={1}>
				<Tooltip title={"search"} placement={"top"} followCursor>
					<IconButton onClick={clickToSearch}>
						<SearchIcon color="info" />
					</IconButton>
				</Tooltip>
			</Grid>
		</Grid>
	)
	// return (
	// 	<Grid
	// 		container
	// 		alignItems={'center'}
	// 		sx={
	// 			sx ?? {
	// 				width: '30%',
	// 				padding: '8px',
	// 			}
	// 		}
	// 	>
	// 		<Grid item xs={11}>
	// 			<TextField
	// 				onChange={(event) => {
	// 					setSingleSelectedValue(event.target.value)
	// 				}}
	// 				value={singleSelectedValue || ''}
	// 				variant="standard"
	// 				sx={{ width: '100%', ...props.sx }}
	// 				type={'text'}
	// 			/>
	// 		</Grid>
	// 		<Grid item xs={1}>
	// 			<IconButton
	// 				onClick={() => {
	// 					handleOnSearch(singleSelectedValue)
	// 				}}
	// 			>
	// 				<SearchIcon color="info" />
	// 			</IconButton>
	// 		</Grid>
	// 	</Grid>
	// )
}
